import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import UploadTrackForm from './UploadTrackForm';
import {actions, category, events, UploadType} from '../../../constants/enums';
import {customEvent} from '../../../utils/analyticsUtil';
import './uploadTrack.scss';
import BaseTrackDialogContainer from './BaseTrackDialogContainer';

@inject('uploadTrackStore', 'looperStore', 'audioStore', 'dialogStore')
@observer
class UploadTrackDialogContainer extends Component {
    @observable header = 'upload.header.uploadFile';
    @observable isBpmOpened = false;

    @action componentWillUpdate = async (nextProps) => {
        const {uploadType} = nextProps.uploadTrackStore;
        const {showUploadDialog} = nextProps.dialogStore;
        if (showUploadDialog) {
            this.assignHeader(uploadType);
        }
    };

    @action toggleBpm = () => {
        customEvent(events.CustomEvent, {category: category.Upload, action: actions.ToggleBpmCalculator});
        this.isBpmOpened = !this.isBpmOpened;
    };

    @action assignHeader = (uploadType) => {
        this.header = `upload.header.${uploadType === UploadType.UploadFile ? 'uploadFile' : 'edit'}`;
    };

    @action handleDialogClose = () => {
        const {uploadTrackStore, audioStore, dialogStore} = this.props;
        uploadTrackStore.init();
        dialogStore.closeUploadDialog();
        audioStore.deleteAudio();
        this.assignHeader(uploadTrackStore.uploadType);
        this.isBpmOpened = false;
    };

    handlePlay = () => {
        this.props.audioStore.play();
    };

    handleStop = () => {
        this.props.audioStore.stop();
    };

    renderForm = () => {
        const {uploadTrackStore} = this.props;
        const {uploadType} = uploadTrackStore;
        return (
            <UploadTrackForm
                toggleBpm={this.toggleBpm}
                onSubmitSuccess={this.handleDialogClose}
                header={this.header}
                showFileUpload={uploadType === UploadType.UploadFile}
            />
        );
    };

    render() {
        const {showUploadDialog} = this.props.dialogStore;

        return (
            <BaseTrackDialogContainer
                toggleBpm={this.toggleBpm}
                showDialog={showUploadDialog}
                renderForm={this.renderForm}
                handlePlay={this.handlePlay}
                handleStop={this.handleStop}
                showBpmCalculator={this.isBpmOpened}
                handleDialogClose={this.handleDialogClose}
            />
        );
    };
}

export default UploadTrackDialogContainer;
